module.exports = __webpack_public_path__ + "img/a_xia_xian2.695ef151.png";